export default __webpack_public_path__ + "static/media/value-reduce.1510de0b.svg";